<template>
<div class="guestAlert-popup">
  <div class="guestAlert-main">
    <div class="main-title">温馨提示</div>
    <div class="main-text">{{ text }}</div>
    <div class="main-confirm" @click="closePopup">确定</div>
  </div>
</div>
</template>
<script>
export default {
  name: "GuestAlert",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  data () {
    return {}
  },
  methods: {
    closePopup () {
      this.$emit("closePopup")
    }
  }
}
</script>
<style scoped lang="less">
.guestAlert-popup{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  position: fixed;
  top:0;
  left: 0;
  z-index: 99;
  .guestAlert-main{
    width: 800px;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    font-weight: bold;
    .main-title{
      padding: 30px 0;
      font-size: 26px;
      line-height: 40px;
      border-bottom: 1px solid #d9d9d9;
      text-align: center;
      color: #fcc300;
    }
    .main-text{
      line-height: 40px;
      font-size: 22px;
      text-align: center;
      margin: 40px 0;
      color: #202020;
    }
    .main-confirm{
      width: 264px;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(90deg, #fcbf00 0%, #ffdb17 100%);
      margin: 0 auto 40px;
      text-align: center;
      font-size: 18px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
</style>